
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcChatMessage as ObcChatMessageElement} from '@oicl/openbridge-webcomponents/dist/components/chat-message/chat-message.js';
 
 
 

 
 export const ObcChatMessage = createComponent({
   react: React,
   tagName: 'obc-chat-message',
   elementClass: ObcChatMessageElement,
   events: {
     
   }
  });
 
 